<template>
  <v-row no-gutters class="head_bgActivity card cardbg">
    <v-app-bar style="background-color: #ffff;min-height: 6vh;" fixed dense>
      <v-col class="pa-0" cols="2" @click="goBack()" icon>
        <v-icon align="center" color="orange">mdi-arrow-left</v-icon>
      </v-col>
      <v-col cols="8" class="d-flex justify-center" style="font-size:20px;">
        วิธีการได้รับคะแนน
      </v-col>
      <v-col cols="2" style="font-size:20px;">
      </v-col>
    </v-app-bar>
    <v-col class="cardbg">
      <div class="mt-9">
        <v-fade-transition mode="out-in">
          <v-container style="min-height: 50vh" class="card1">
            <div>

              <v-expansion-panels v-model="panel" :disabled="disabled" multiple focusable>
                <v-expansion-panel>
                  <v-expansion-panel-header
                    class="font16 " :style="{'color': $CUSTOMMainTextColor, 'backgroundColor': $bgColor} ">ได้คะแนนจากการใช้บริการหรือซื้อสินค้า</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    สินค้า/บริการ
                    <ul v-for="(item, i) in productEx.filter(a => a.status !== 'False')" :key="i">
                      <strong v-if="item.status !== 'False'" style="display:flex">- บริการ/สินค้า <div
                          style="margin-left:10px" class="font16 " :style="{'color': $CUSTOMMainTextColor}">{{ item.name }}</div></strong>
                      <p>{{ item.detail }}</p>
                    </ul>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel focusable>
                  <v-expansion-panel-header
                    class="font16 " :style="{'color': $CUSTOMMainTextColor, 'backgroundColor': $bgColor} ">ได้คะแนนจากการเล่นกิจกรรม</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    กิจกรรมทั้งหมด
                    <ul v-for="(item, i) in activity" :key="i">
                      <strong style="display:flex">-กิจกรรม
                        <div style="margin-left:10px"
                          class="font16 " :style="{'color': $CUSTOMMainTextColor}">
                          {{ item.title }} ได้ {{ item.coin }}
                        </div>
                        <v-avatar size="25" class="ms-3">
                          <v-img :src="$images.point" height="25" width="25"/>
                        </v-avatar>
                      </strong>
                    </ul>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </v-container>
        </v-fade-transition>
      </div>
    </v-col>
  </v-row>
</template>
<style scoped>
.card1 {
  height: 100%;
  overflow: hidden;
  background-color: #fff !important;
  border-radius: 0px 0px 0px 0px;
}

.card {
  height: 100%;
  overflow: hidden;
}

.cardbg {
  margin-top: 10px;
  background-repeat: no-repeat !important;
  background-size: 90% 110% !important;
  background-attachment: fixed;
  background-position: center;
}
</style>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'HowToGetCoin',
  data () {
    return {
      activity: null,
      productEx: null,
      today: new Date(),
      profile: [],
      panel: [0, 1],
      disabled: false,
      readonly: false,
      member: null,
      shopId: null
    }
  },
  async mounted () {
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    this.shopId = this.GET_SHOPID()

    await this.getActivity()
    await this.getProductEx()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),

    async getActivity () {
      const result = await this.callBeTaskAPI('get', `/activity/line/get`)
      if (Array.isArray(result)) {
        this.activity = result.filter(
          (a) =>
            new Date(a.startDate).getTime() <= this.today.getTime() &&
            this.today.getTime() < new Date(a.endDate).getTime()
        )
      }
    },
    async getProductEx () {
      const result = await this.callBeTaskAPI('get', `/productExchangeRate/get?shopId=${this.shopId}`)
      if (Array.isArray(result)) {
        this.productEx = result
      }
    },
    goBack () {
      window.history.back()
    }
  }
}
</script>
<style scoped>
div.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}

.coin_icon::after {
  margin-left: 6px;
  margin-top: 0px;
  content: "";
  background-image: var(--coin_img);
  background-size: 23px 26px;
  display: inline-block;
  width: 25px;
  height: 25px;
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/components/HowToGetCoin.vue